// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as PlApi from "../player/PlApi.bs.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlState from "./PlState.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as PlFilter from "./PlFilter.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as PlInfoWrap from "./PlInfoWrap.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as DelayedLoader from "../components/DelayedLoader.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as LbPlayerSearch from "../leaderboards/LbPlayerSearch.bs.js";
import * as PlExpandedMatch from "./PlExpandedMatch.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";

function useRouteUpdates(player, expandedMatchId, dispatch) {
  var currPlayerRoutePushed = React.useRef(false);
  React.useEffect((function () {
          if (player !== undefined && player.TAG === /* Ok */0) {
            var player$1 = player._0;
            var fn = currPlayerRoutePushed.current ? Route.replace : Route.push;
            Curry._1(fn, {
                  TAG: /* Player */2,
                  _0: {
                    region: Region.fromApiName(player$1.playerInfo.region),
                    playerName: player$1.playerInfo.name,
                    tag: player$1.playerInfo.tag,
                    match: expandedMatchId
                  }
                });
            currPlayerRoutePushed.current = true;
          }
          
        }), [expandedMatchId]);
  
}

function PlPage$Inner(Props) {
  var initialData = Props.initialData;
  var player = Props.player;
  var tag = Props.tag;
  var matchId = Props.matchId;
  var initialMatchData = Props.initialMatchData;
  var setSet = Props.setSet;
  var set = TftSet.use(undefined);
  var router = Router.use(undefined);
  var match = React.useReducer(PlState.reducer, PlState.getInitialState(player, tag, initialData, matchId));
  var dispatch = match[1];
  var state = match[0];
  React.useState(function () {
        return PlFilter.$$default;
      });
  var setExpandedMatchId = React.useCallback((function (matchId) {
          return Curry._1(dispatch, {
                      TAG: /* SetExpandedMatchId */11,
                      _0: matchId
                    });
        }), []);
  var match$1 = React.useState(function () {
        
      });
  var setHoveredMatchId = match$1[1];
  var onHoverMatch = React.useCallback((function (matchId) {
          return Curry._1(setHoveredMatchId, (function (param) {
                        return matchId;
                      }));
        }), []);
  var route = Route.fromPath(Belt_List.fromArray(Belt_Array.keep(router.asPath.split("/"), (function (s) {
                  return s !== "";
                }))), "");
  var match$2;
  if (typeof route === "number" || route.TAG !== /* Player */2) {
    match$2 = [
      undefined,
      undefined,
      undefined
    ];
  } else {
    var match$3 = route._0;
    match$2 = match$3 !== undefined ? [
        match$3.region,
        match$3.playerName,
        match$3.tag
      ] : [
        undefined,
        undefined,
        undefined
      ];
  }
  var routeTag = match$2[2];
  var routePlayerName = match$2[1];
  var routeRegion = match$2[0];
  React.useEffect((function () {
          if (routeRegion !== undefined && routePlayerName !== undefined) {
            Curry._1(dispatch, {
                  TAG: /* UpdatePlayerInput */0,
                  _0: routeRegion,
                  _1: routePlayerName + Belt_Option.mapWithDefault(routeTag, "", (function (v) {
                          return "#" + v;
                        }))
                });
            Curry._1(dispatch, /* Search */4);
          }
          
        }), [
        routeRegion,
        routePlayerName
      ]);
  React.useEffect((function () {
          var cancelled = {
            contents: false
          };
          var match = state.playerSearch;
          if (match !== undefined) {
            var playerName = match[1];
            var region = match[0];
            $$Promise.consume(PlApi.getPlayer(region, playerName, set, match[2], undefined), (function (playerResp) {
                    if (cancelled.contents) {
                      return ;
                    }
                    var shouldUpdate;
                    if (playerResp.TAG === /* Ok */0) {
                      shouldUpdate = true;
                    } else {
                      var match = state.player;
                      var exit = 0;
                      if (match !== undefined && match.TAG === /* Ok */0) {
                        var player = match._0;
                        shouldUpdate = PlUtils.reducePlayerName(player.playerInfo.name) !== PlUtils.reducePlayerName(playerName) || player.playerInfo.region !== Region.toApiName(region);
                      } else {
                        exit = 1;
                      }
                      if (exit === 1) {
                        shouldUpdate = initialData !== undefined ? PlUtils.reducePlayerName(initialData.playerInfo.name) !== PlUtils.reducePlayerName(playerName) || initialData.playerInfo.region !== Region.toApiName(region) : true;
                      }
                      
                    }
                    if (shouldUpdate) {
                      Curry._1(dispatch, {
                            TAG: /* SetPlayerResp */3,
                            _0: playerResp
                          });
                      if (playerResp.TAG !== /* Ok */0) {
                        return Curry._1(dispatch, /* ResetRecentlyUpdated */2);
                      }
                      setTimeout((function (param) {
                              return Curry._1(dispatch, /* ResetRecentlyUpdated */2);
                            }), 30000);
                      return ;
                    }
                    Curry._1(dispatch, /* ResetRecentlyUpdated */2);
                    var cb = SnackbarService.sub.contents;
                    if (cb !== undefined) {
                      return Curry._1(cb, "Update failed. Data shown may not be up to date.");
                    }
                    
                  }));
          }
          return (function (param) {
                    cancelled.contents = true;
                    
                  });
        }), state.playerSearch);
  PlState.usePlayerDataFetching(state, dispatch, set);
  useRouteUpdates(state.player, state.expandedMatchId, dispatch);
  var adKey = Belt_Option.mapWithDefault(routeRegion, "", Region.toApiName) + "__" + Belt_Option.getWithDefault(routePlayerName, "");
  var match$4 = state.playerSearch;
  var tmp;
  if (match$4 !== undefined) {
    var match$5 = state.player;
    var match$6 = state.initialData;
    var exit = 0;
    var player$1;
    if (match$5 !== undefined) {
      if (match$5.TAG === /* Ok */0) {
        player$1 = match$5._0;
        exit = 1;
      } else {
        var match$7 = match$5._0;
        tmp = match$7[2] ? React.createElement(ContentSection.make, {
                children: "Something went wrong. Try again in a minute."
              }) : React.createElement(ContentSection.make, {
                children: "Summoner " + match$7[1] + " in " + Region.toName3(match$7[0]) + " region was not found."
              });
      }
    } else if (match$6 !== undefined) {
      player$1 = match$6;
      exit = 1;
    } else {
      tmp = React.createElement(React.Fragment, undefined, React.createElement(DelayedLoader.make, {}));
    }
    if (exit === 1) {
      tmp = React.createElement(PlInfoWrap.make, {
            region: match$4[0],
            pname: match$4[1],
            tag: match$4[2],
            player: player$1,
            state: state,
            dispatch: dispatch,
            adKey: adKey,
            setExpandedMatchId: setExpandedMatchId,
            onHoverMatch: onHoverMatch,
            setSet: setSet
          });
    }
    
  } else {
    tmp = null;
  }
  var tmp$1 = {
    onClose: (function (param) {
        return Curry._1(setExpandedMatchId, undefined);
      })
  };
  var tmp$2 = Belt_Option.map(state.playerSearch, (function (param) {
          return param[1];
        }));
  if (tmp$2 !== undefined) {
    tmp$1.heroName = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = Belt_Option.flatMap(state.playerSearch, (function (param) {
          return param[2];
        }));
  if (tmp$3 !== undefined) {
    tmp$1.heroTag = Caml_option.valFromOption(tmp$3);
  }
  var tmp$4 = match$1[0];
  if (tmp$4 !== undefined) {
    tmp$1.hoveredMatchId = Caml_option.valFromOption(tmp$4);
  }
  if (state.expandedMatchId !== undefined) {
    tmp$1.expandedMatchId = Caml_option.valFromOption(state.expandedMatchId);
  }
  if (initialMatchData !== undefined) {
    tmp$1.initialMatchData = Caml_option.valFromOption(initialMatchData);
  }
  return React.createElement(AdLayout.make, {
              adKey: adKey,
              children: React.createElement("div", {
                    className: "mx-auto w-screen md:w-[928px] xl:w-[950px]"
                  }, React.createElement("div", {
                        className: "flex w-full justify-center"
                      }, React.createElement(LbPlayerSearch.make, {})), React.createElement("div", {
                        className: "flex flex-col mt-6 lg:mt-8"
                      }, tmp), React.createElement(PlExpandedMatch.make, tmp$1))
            });
}

var Inner = {
  make: PlPage$Inner
};

function PlPage(Props) {
  var initialData = Props.initialData;
  var player = Props.player;
  var tag = Props.tag;
  var match = Props.match;
  var matchId = Props.matchId;
  var initialMatchData = Props.initialMatchData;
  var match$1 = React.useState(function () {
        return /* Set18 */10;
      });
  var setSet = match$1[1];
  var set = match$1[0];
  var setSet2 = React.useCallback((function (set) {
          return Curry._1(setSet, (function (param) {
                        return TftSet.fromNum(set);
                      }));
        }), []);
  var initialData$1 = set !== 4 ? undefined : initialData;
  var tmp = {
    setSet: setSet2,
    key: set
  };
  if (initialData$1 !== undefined) {
    tmp.initialData = Caml_option.valFromOption(initialData$1);
  }
  if (player !== undefined) {
    tmp.player = Caml_option.valFromOption(player);
  }
  if (tag !== undefined) {
    tmp.tag = Caml_option.valFromOption(tag);
  }
  if (match !== undefined) {
    tmp.match = Caml_option.valFromOption(match);
  }
  if (matchId !== undefined) {
    tmp.matchId = Caml_option.valFromOption(matchId);
  }
  if (initialMatchData !== undefined) {
    tmp.initialMatchData = Caml_option.valFromOption(initialMatchData);
  }
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(set, React.createElement(PlPage$Inner, tmp), undefined));
}

var make = PlPage;

export {
  useRouteUpdates ,
  Inner ,
  make ,
  
}
/* PlApi Not a pure module */
